export const formatDateForApi = (date: Date, hideTimeString?: boolean) => {
  let dateStr = `${date.getFullYear()}`;
  dateStr += "-";
  dateStr += `0${date.getMonth() + 1}`.slice(-2);
  dateStr += "-";
  dateStr += `0${date.getDate()}`.slice(-2);
  dateStr += hideTimeString ? "" : "T00:00:00";

  return dateStr;
};
